import React, {FC} from "react";
import {OfficesListProps} from "./types";
import {Button, Dropdown, Empty, Skeleton} from "antd";
import type {MenuProps} from "antd";
import {MdMedicalInformation} from "react-icons/md";
import {Link} from "react-router-dom";
import OfficeModal from "../../../../../components/modals/office-modal/OfficeModal";
import {DeleteOutlined, EditOutlined, MoreOutlined, RightOutlined} from "@ant-design/icons";
import "./style.less"
import {useAuth} from "../../../../../context/authContext";
import {OfficeItem} from "../../../../../types/office";

const OfficesList: FC<OfficesListProps> = ({officesController}) => {
  const {officesList, isLoading, confirmDeleteOffice, editButtonHandler} = officesController
  const {canManageContent} = useAuth()

  const getAdminMenu = (office: OfficeItem): MenuProps["items"] => [
    {key: "edit", icon: <EditOutlined/>, label: "Редагувати", onClick: () => editButtonHandler(office)},
    {key: "delete", danger: true, icon: <DeleteOutlined/>, label: "Видалити", onClick: () => confirmDeleteOffice({officeId: office.$id || "", officeName: office.name})},
  ]

  return <>
    {isLoading && officesList.length === 0
      ? <div className="offices-grid offices-grid--loading">{[0, 1, 2].map((item) => <div className="office-skeleton" key={item}><Skeleton active paragraph={{rows: 1}}/></div>)}</div>
      : officesList.length === 0
        ? <div className="offices-empty"><Empty description="Амбулаторії ще не додано"/></div>
        : <div className={`offices-grid ${isLoading ? "offices-grid--updating" : ""}`}>
          {officesList.map((office) => <article className="office-card" key={office.$id || office.name}>
            <Link className="office-card__link" to={`/office/${office.$id}`}>
              <span className="office-card__icon"><MdMedicalInformation/></span>
              <h3 className="office-card__title">{office.name}</h3>
              <span className="office-card__more">Переглянути <RightOutlined/></span>
            </Link>
            {canManageContent && <Dropdown menu={{items: getAdminMenu(office)}} trigger={["click"]}>
              <Button className="office-card__admin" type="text" shape="circle" icon={<MoreOutlined/>}
                      aria-label={`Керування амбулаторією: ${office.name}`}/>
            </Dropdown>}
          </article>)}
        </div>}
    <OfficeModal officesController={officesController}/>
  </>
}

export default OfficesList
